
import Vue from 'vue'
import ContactInputSummary from './ContactInputSummary.vue'
import OrderTypeSummary from './OrderTypeSummary.vue'
import BillingInputSummary from './BillingInputSummary.vue'
import ShippingInputSummary from './ShippingInputSummary.vue'
import PaymentInputSummary from './PaymentInputSummary.vue'

export default Vue.extend({
   name: 'InputSummary',
   components: {
      ContactInputSummary,
      OrderTypeSummary,
      BillingInputSummary,
      ShippingInputSummary,
      PaymentInputSummary,
   },
   computed: {
      showSummary(): boolean {
         return this.$store.state.viewedSteps.length > 0
      },
   },
})
